import React from "react";
import { func } from "../../../../../utils";
import _function from "../../../../../utils/function";
import useWindowSize from "../../../../../hooks/useWindowSize";
import { usePageContextState } from "../../../../../context/PageContext";
import { useNavigate } from "react-router-dom";
import { useURLParams } from "../../../../../hooks/useURLParams";
import { ScrollDownIcon } from "../Banner.styled";

const BannerSocV2 = ({ data, slug, children }) => {
  const { isLive } = usePageContextState();
  const navigate = useNavigate();
  const { size } = useWindowSize();
  const { buildURLWithParams } = useURLParams();
  const isMobileView = (size?.width || 0) <= 830;

  const handleScroll = () => {
    _function.scrollTo("guest-star");
  };

  const MobileBanner = () => (
    <div className="relative w-full h-[693px] max-w-[375px] mx-auto">
      {/* Background Image */}

      {/* KV Piala byU Image */}
      <img
        src={func.getStaticImg(
          "illustration/conference/v2/kv-mobile-701f8c.png"
        )}
        alt="KV Piala byU"
        className="absolute w-[369px] h-[280px] object-stretch"
        style={{ left: "1px", top: "56px" }}
      />

      {/* Asset Headline */}
      <img
        src={func.getStaticImg(
          "illustration/conference/v2/headline-mobile.png"
        )}
        alt="headline"
        className="absolute w-[386.78px] h-[230.27px] object-cover"
        style={{ left: "-5.89px", top: "276.12px" }}
      />

      {/* Asset Venue */}
      <img
        src={func.getStaticImg(
          "illustration/conference/v2/venue-homepage-mobile-7329ee.png"
        )}
        alt="venue"
        className="absolute w-[225px] h-[89px] object-stretch"
        style={{ left: "75px", top: "508px" }}
      />

      {/* Scroll Down Component */}
      <div
        className="absolute flex flex-col items-center gap-[-2px]"
        style={{ left: "129px", top: "615px" }}
      >
        <span className="text-white font-bold text-[16px] leading-[1.5em] tracking-[0.5%] font-['Gilroy']">
          Scroll Kebawah
        </span>

        <ScrollDownIcon
          onClick={handleScroll}
          alt="scroll-down"
          src={func.getStaticImg(
            "illustration/conference/v2/scroll-down-icon.svg"
          )}
        />
      </div>
    </div>
  );

  const DesktopBanner = () => (
    <div className="relative w-full h-[780px] max-w-[1440px] mx-auto">
      {/* Background KV Image */}
      <img
        src={func.getStaticImg(
          "illustration/conference/v2/kv-background-desktop.png"
        )}
        alt="KV background"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ top: "-58px", height: "900px" }}
      />

      {/* Content Container */}
      <div className="absolute top-[118px] right-[108px] w-[618px] flex flex-col items-center">
        {/* Title */}
        <div className="mb-6">
          <img
            src={func.getStaticImg(
              "illustration/conference/v2/title-d-soc.png"
            )}
            alt="title"
            className="w-full max-w-[599px] h-[357px] object-contain"
          />
        </div>

        {/* Asset Venue */}
        <div className="mb-8">
          <img
            src={func.getStaticImg(
              "illustration/conference/v2/venue-homepage-desktop-7329ee.png"
            )}
            alt="venue"
            className="w-[378px] h-[150px] object-cover"
          />
        </div>

        {/* Scroll Down Component */}
        <div className="flex flex-col items-center gap-[-2px]">
          <span className="text-white font-bold text-[16px] leading-[1.5em] tracking-[0.5%] font-['Gilroy']">
            Scroll Kebawah
          </span>
          <ScrollDownIcon
            onClick={handleScroll}
            alt="scroll-down"
            src={func.getStaticImg(
              "illustration/conference/v2/scroll-down-icon.svg"
            )}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div
      id="banner-landing"
      className="relative overflow-hidden"
      style={{
        width: isMobileView ? "375px" : "1440px",
        height: isMobileView ? "693px" : "780px",
        margin: "0 auto",
      }}
    >
      {isMobileView ? <MobileBanner /> : <DesktopBanner />}
    </div>
  );
};

export default BannerSocV2;
